// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

type RuntimeHostSettings = Partial<{
    api_url: string;
    web_url: string;
    mobile_url: string;

    app: string;
    avatar: string;
    code: string;
    name: string;

    layout: {
        logo?: string;
        theme?: string;
        watermark?: string;
        favicon?: string;
    };
    support: {
        email?: string;
        mobile?: string;
        lastname?: string;
        othernames?: string;
    };
}>;

declare global {
    interface Window {
        __HOST_SETTINGS__?: RuntimeHostSettings;
    }
}

const runtimeSettings: RuntimeHostSettings = typeof window !== 'undefined'
    ? window.__HOST_SETTINGS__ || {}
    : {};

export const environment = {
    production: false,
    api_url: 'https://api.ashcorp.xyz',
    app: 'DEMO',
    avatar: 'https://cloud.ashcorp.co/index.php/s/g7ewbkDSAY6eTC3/download/avatar-20260328152021-746da634.jpeg',

    code: 'DEMO',
    name: 'DEMO',
    web_url: 'https://demo.ashcorp.xyz',
    mobile_url: 'https://mobile.ashcorp.co',
    layout: {
        logo: 'https://cloud.ashcorp.co/index.php/s/fX7kZWEkEysJrqb/download/logo-20260328151452-e9f33243.png',
        theme: 'default',
        watermark: 'https://cloud.ashcorp.co/index.php/s/Btp2mpragCTSniC/download/watermark-20260328151320-0bcf126c.png',
        favicon: 'https://cloud.ashcorp.co/index.php/s/MwMofkqidT9pYPZ/download/favicon-20260328151518-4af7f78e.png'
    },
    support: {
        email: 'support@ashcorp.co',
        mobile: '59729663',
        lastname: 'Addams',
        othernames: 'Asher'
    },
    ...runtimeSettings
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
